export default class Permissions {

    static account = {
        add: 1000,
        edit: 1010,
        delete: 1020,
        changeStatus: 1030,
        isInternal: {
            edit: 1130
        }
    }

    static subscription = {
        add: 2000,
        edit: 2010,
        delete: 2020,
        changeStatus: 2030
    }

    static product = {
        add: 3000,
        edit: 3010,
        delete: 3020,
        changeStatus: 3030
    }

    static user = {
        add: 4000,
        edit: 4010,
        delete: 4020,
        changeStatus: 4030
    }


}


// WEBPACK FOOTER //
// ./src/authentication/Permissions.js